import React, { Suspense, lazy } from 'react';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
// Lazy-load below-the-fold sections to shrink initial JS bundle and speed up first paint
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const ProductIntro = lazy(() => import('./components/ProductIntro').then(m => ({
  default: m.ProductIntro
})));
const MethodPillars = lazy(() => import('./components/MethodPillars').then(m => ({
  default: m.MethodPillars
})));
const WhatsIncluded = lazy(() => import('./components/WhatsIncluded').then(m => ({
  default: m.WhatsIncluded
})));
const TransformationSection = lazy(() => import('./components/TransformationSection').then(m => ({
  default: m.TransformationSection
})));
const AudienceSection = lazy(() => import('./components/AudienceSection').then(m => ({
  default: m.AudienceSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const FloatingCTA = lazy(() => import('./components/FloatingCTA').then(m => ({
  default: m.FloatingCTA
})));
const RecentPurchaseToast = lazy(() => import('./components/RecentPurchaseToast').then(m => ({
  default: m.RecentPurchaseToast
})));
const BundleUpsellPopup = lazy(() => import('./components/BundleUpsellPopup').then(m => ({
  default: m.BundleUpsellPopup
})));
// Wrapper that defers rendering of off-screen sections until they near the viewport.
// `content-visibility: auto` skips layout, paint, and even render work for sections
// that aren't visible — a major mobile performance gain (FCP / TBT / LCP).
function Deferred({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="cv-auto" data-id="element-0">{children}</div>;
}
export function App() {
  return <div className="min-h-screen w-full" data-id="element-1">
      <TopBar data-id="element-2" />
      <HeroSection data-id="element-3" />
      <Suspense fallback={null} data-id="element-4">
        <FloatingCTA data-id="element-5" />
        <RecentPurchaseToast data-id="element-6" />
        <BundleUpsellPopup data-id="element-7" />
        <Deferred data-id="element-8">
          <ProblemSection data-id="element-9" />
        </Deferred>
        <Deferred data-id="element-10">
          <ProductIntro data-id="element-11" />
        </Deferred>
        <Deferred data-id="element-12">
          <MethodPillars data-id="element-13" />
        </Deferred>
        <Deferred data-id="element-14">
          <WhatsIncluded data-id="element-15" />
        </Deferred>
        <Deferred data-id="element-16">
          <TransformationSection data-id="element-17" />
        </Deferred>
        <Deferred data-id="element-18">
          <AudienceSection data-id="element-19" />
        </Deferred>
        <Deferred data-id="element-20">
          <GuaranteeSection data-id="element-21" />
        </Deferred>
        <Deferred data-id="element-22">
          <FinalCTA data-id="element-23" />
        </Deferred>
        <Deferred data-id="element-24">
          <Footer data-id="element-25" />
        </Deferred>
      </Suspense>
    </div>;
}